import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home/home.services';
import { DataDirectoryService } from '../data-directory/data-directory.service';
import { ToastMessageService } from 'src/app/toastr.service';


@Component({
    selector: 'app-est-calculation',
    templateUrl: './est-calculation.component.html',
    styleUrls: ['./est-calculation.component.scss']
})
export class EstCalculationComponent implements OnInit {

    constructor(private toastService: ToastMessageService, private homeservice: HomeService, private directoryservice: DataDirectoryService) {
    }

    allMoleculeData;
    searchValue = '';
    email: any;

    ngOnInit(): void {
        this.email = localStorage.getItem("email");
    }

    clearFilter() {
        this.searchValue = ""
        this.allMoleculeData = []
    }

    searchMolecule() {
        let data = {
            atc_class: this.searchValue,
            user_email: this.email
        }
        this.homeservice.getRldMoleculeData(data).subscribe((response) => {
            this.allMoleculeData = response['data']['data']
            // console.log(this.allMoleculeData);

            for (let i = 0; i < this.allMoleculeData.length; i++) {
                if (this.allMoleculeData[i] && this.allMoleculeData[i].Strengths) {
                    for (let j = 0; j < this.allMoleculeData[i].Strengths.length; j++) {
                        if (this.allMoleculeData[i].Strengths[j]["Per unt price"] == 0) {
                            this.allMoleculeData[i].calcBtn = true;
                        }
                    }
                }
            }

            if (response['message'] == 'success') {
                this.toastService.success('Data Fetched Successfully');
                return;
            }
            else {
                this.toastService.error('Data Not Found !');
                return;
            }
        })
    }

    calculateMolecule(i, j, search, ndaNumber, strength, gname) {
        console.log(i, j);

        let data = {
            atc_class: search,
            nda_number: ndaNumber,
            strength: strength,
            Generic_name: gname
        }

        if (!data.atc_class || !data.nda_number || !data.strength || !data.Generic_name) {
            this.toastService.error('Missing required field !');
            return;
        }

        this.homeservice.saveMoleculeRld(data).subscribe((response) => {
            if (response['message'] == 'success') {
                this.toastService.success('Data Fetched Successfully');

                this.allMoleculeData[i].Strengths[j]["Per unt price"] = response["data"]["harmonic_mean"]
                this.allMoleculeData[i].calcBtn = false;
                this.allMoleculeData[i].saveBtn = true;
                return;
            }
            else {
                this.toastService.error('Data Not Found !');
                this.searchMolecule()
                return;
            }
        })
    }

    saveMolecule(value, strength, ndaNumber) {
        let data = {
            user_email: this.email,
            value: value,
            nda_number: ndaNumber,
            strength: strength,
        }
        console.log(data);


        if (!data.value || !data.nda_number || !data.strength) {
            this.toastService.error('Missing required field !');
            return;
        }

        this.homeservice.saveEstRld(data).subscribe((response) => {
            this.allMoleculeData = response['data']['data']
            if (response['message'] == 'success') {
                this.toastService.success('Data saved Successfully');
                this.searchMolecule()
                return;
            }
            else {
                this.toastService.error('Data Not Found !');
                this.searchMolecule()
                return;
            }
        })
    }
}
